import React from 'react';

const ICON_ID = 'icon-road';

const IconRoad = function(props) {
  return (
    <svg viewBox="0.584 11.073 47.025 25.888" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Road Icon</title>
    	<g transform="translate(0, 11)">
    		<path id="Stroke-3" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M4.104,0.645h39.983"/>
    		<path id="Stroke-5" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M4.104,25.39h39.983"/>
    		<path id="Stroke-7" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M17.014,13.396h-6.798"/>
    		<path id="Stroke-9" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M27.496,13.396h-6.799"/>
    		<path id="Stroke-11" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M37.977,13.396h-6.799"/>
    		<path id="Stroke-13" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M5.642,13.396H0.584"/>
    		<path id="Stroke-15" fill="none" strokeWidth="1.143" strokeLinejoin="round" d="M47.609,13.396h-5.06"/>
    	</g>
    </svg>
  )
}

export default IconRoad;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-road.jsx